import { useEntity } from "apps/console/context/entity";
import ConsoleApi from "apps/console/enums/consoleApi";
import { useGetApiData } from "shared/datalayer";
import { ApiRegistrationParticipantSearchResult } from "shared/types/ApiRegistrationParticipantSearchResult";

export function useGetBulkTicketAdminsByRegistration() {
  const { registrationId } = useEntity();
  return useGetApiData<Array<ApiRegistrationParticipantSearchResult>>(
    ConsoleApi.GET_BULK_TICKET_ADMINS_BY_REGISTRATION_ID,
    {
      params: {
        registrationId
      }
    }
  );
}
